import Select from "@atlaskit/select";
import type {ComponentProps} from "react";

// <{
//     // id: Uuid;
//     id: string;
//     label: string;
// }>
export function AnankeSelect(props: ComponentProps<typeof Select>) {
    return <Select {...props} />;
}
